/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TagLabel/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import Info from 'DesignSystem/Info/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TagLabel({
  children,
  viewPath = "/DesignSystem/TagLabel",
  marginTop = 0,
  tagText = "MM/DD/YYYY",
  width = 80,
  labelText = "Date of birth"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="TagLabel.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-ZPNaqy': typeof marginTop === 'number' ? `${marginTop}px` : marginTop}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="TagLabel.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Info
  viewPath={`${viewPath}/Info`}
 text={tagText}
 lineHeight={1.2}
/>
</div>
<span
  data-testid="TagLabel.Text"
  data-view-path={viewPath}
 style={{'--w-2-ZPNaqy': typeof width === 'number' ? `${width}px` : width}}
 className={`views-text ${styles.Text}`}
>
{labelText}
</span>
</div>
{children}
</React.Fragment>)
}